import { useSelector } from 'app-redux'
import { uniq } from 'lodash'
import { useMemo } from 'react'
import useFetchMissingProfiles from 'users/use-fetch-missing-profiles'
import { roomUserIds } from './redux'
import { useAssertedWorkflowUser } from './use-workflow-user'

/**
 * Loads the profiles of everyone in the joined room, the user's own and the
 * trainer's included.
 *
 * Screens such as the whiteboard, the notepad and the knowledge-check views
 * read profiles from the store and never fetch them; the whiteboard does not
 * even mount without the user's own. Online the device check and the lobby
 * load them on the way in. An in-person session skips both, so without this
 * nothing loads them - and the trainer's whiteboard stayed blank.
 */
export const useRoomProfiles = (): void => {
	const workflowUser = useAssertedWorkflowUser()
	const trainerId = useSelector(
		state => state.sessionInfo.training?.upperEchelon.userId
	)
	const userIds = useSelector(roomUserIds)

	const required = useMemo(
		() =>
			uniq([...userIds, workflowUser.id, ...(trainerId ? [trainerId] : [])]),
		[userIds, workflowUser.id, trainerId]
	)

	useFetchMissingProfiles(required)
}
